import { render, staticRenderFns } from "./SingleResponseItem.vue?vue&type=template&id=6f2bd36c&scoped=true&"
import script from "./SingleResponseItem.vue?vue&type=script&lang=js&"
export * from "./SingleResponseItem.vue?vue&type=script&lang=js&"
import style0 from "./SingleResponseItem.vue?vue&type=style&index=0&id=6f2bd36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2bd36c",
  null
  
)

export default component.exports